import React, { useRef, useState } from "react";
import { AutoComplete, Typography } from "antd";
import "../../../../../../components/common/EditableCellGrid/EditableCellGrid.css";
import { isRecommendedStcType, normalizeStcTypeValue, RECOMMENDED_STC_TYPE_OPTIONS, STC_CUSTOM_VALUE_WARNING } from "../../../constants/scheduleDraftOptions";

const { Text } = Typography;

const STCCellEditor = ({ row, column, onRowChange, onClose }) => {
    const initialValue = normalizeStcTypeValue(row[column.key]);
    const [value, setValue] = useState(initialValue);
    const valueRef = useRef(initialValue);
    const closedRef = useRef(false);
    const showCustomWarning = value !== "" && !isRecommendedStcType(value);

    const commitValue = (nextValue, shouldFocusCell = true) => {
        if (closedRef.current) {
            return;
        }

        const normalizedValue = normalizeStcTypeValue(nextValue);
        const committedValue = normalizedValue || null;
        closedRef.current = true;
        valueRef.current = normalizedValue;
        setValue(normalizedValue);
        onRowChange({ ...row, [column.key]: committedValue, rawFlight: { ...(row.rawFlight || {}), stc_type: committedValue } }, true);
        onClose(true, shouldFocusCell);
    };

    const handleChange = (nextValue) => {
        const normalizedValue = normalizeStcTypeValue(nextValue);
        valueRef.current = normalizedValue;
        setValue(normalizedValue);
    };

    const handleInputKeyDown = (event) => {
        if (event.key === "Escape") {
            event.preventDefault();
            event.stopPropagation();
            closedRef.current = true;
            onClose(false, false);
            return;
        }

        if (event.key === "Enter") {
            event.preventDefault();
            event.stopPropagation();
            commitValue(valueRef.current, false);
        }
    };

    return (
        <div className="editable-cell-editor schedule-draft-rdg-stc-editor">
            <AutoComplete
                autoFocus
                allowClear
                aria-label="STC"
                className="editable-cell-editor schedule-draft-rdg-editor-autocomplete"
                value={value}
                options={RECOMMENDED_STC_TYPE_OPTIONS}
                onChange={handleChange}
                onSelect={(nextValue) => commitValue(nextValue, true)}
                onInputKeyDown={handleInputKeyDown}
                onBlur={() => commitValue(valueRef.current, true)}
                getPopupContainer={() => document.body}
                popupMatchSelectWidth={false}
                filterOption={(inputValue, option) => String(option?.value || "").includes(normalizeStcTypeValue(inputValue))}
            />
            {showCustomWarning ? <Text type="warning" className="schedule-draft-rdg-stc-warning">{STC_CUSTOM_VALUE_WARNING}</Text> : null}
        </div>
    );
};

export default STCCellEditor;
